var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { WalletDialogContext } from './useWalletDialog';
import { WalletDialog } from './WalletDialog';
export const WalletDialogProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const [open, setOpen] = useState(false);
    return (React.createElement(WalletDialogContext.Provider, { value: {
            open,
            setOpen,
        } },
        children,
        React.createElement(WalletDialog, Object.assign({}, props))));
};
//# sourceMappingURL=WalletDialogProvider.js.map